var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"PAGE_DOWN","name":"PAGE_DOWN","data-vcode":"PAGE_DOWN"}},[_c('img',{attrs:{"src":"/images/icons/pageDown.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('pageDown')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }